import { render, staticRenderFns } from "./zatca-phase-2.vue?vue&type=template&id=474820ee&scoped=true"
import script from "./zatca-phase-2.vue?vue&type=script&lang=js"
export * from "./zatca-phase-2.vue?vue&type=script&lang=js"
import style0 from "./zatca-phase-2.vue?vue&type=style&index=0&id=474820ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474820ee",
  null
  
)

export default component.exports